import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-questions-stats',
  templateUrl: './questions-stats.component.html',
  styleUrls: ['./questions-stats.component.scss']
})
export class QuestionsStatsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
